import { memo as Memo } from 'react'

//* Components
import Image from 'components/common/Image'
import Video from 'components/common/Video'

//* Style
import IndividualHeroStyle from './style'

const IndividualHero = Memo(({ className, banner }) => {
	return (
		<IndividualHeroStyle className={`${className || ''}`}>
			{banner.type === 'image' ? <Image priority src={banner.url} alt={banner.alt} /> : <Video src={banner.url} autoplay={true} loop={true} />}
		</IndividualHeroStyle>
	)
})

export default IndividualHero
